var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfile = function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2219_2231)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2219_2231",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2219_2231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3337 9.91634C16.3337 8.36925 15.7191 6.88551 14.6251 5.79155C13.5312 4.69759 12.0474 4.08301 10.5003 4.08301C8.95323 4.08301 7.4695 4.69759 6.37554 5.79155C5.28157 6.88551 4.66699 8.36925 4.66699 9.91634C4.66699 11.4634 5.28157 12.9472 6.37554 14.0411C7.4695 15.1351 8.95323 15.7497 10.5003 15.7497C12.0474 15.7497 13.5312 15.1351 14.6251 14.0411C15.7191 12.9472 16.3337 11.4634 16.3337 9.91634Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6668 23.9167C18.6668 21.7507 17.8064 19.6735 16.2749 18.142C14.7433 16.6104 12.6661 15.75 10.5002 15.75C8.33423 15.75 6.257 16.6104 4.72546 18.142C3.19391 19.6735 2.3335 21.7507 2.3335 23.9167M23.3335 18.6667H25.6668",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8335 14H25.6668",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8335 16.333H25.6668",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1665 18.667L25.6665 18.667",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2219_2231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "currentColor"
  })))));
};
export default SvgProfile;